import React, { FC } from 'react';

import { GastronomGrid } from '../../../components';
import { FoodTray, SelectedFoodTrayIndex } from '../../../models';

import './LiveGastronom.scss';

interface Props {
  foodTrays: FoodTray[];
  selectedFoodTray?: SelectedFoodTrayIndex;
  setSelectedFoodTray?: (selectedFoodTray: SelectedFoodTrayIndex) => void;
  containingFoodLineId?: string;
  setContainingFoodLineId?: (id: string) => void;
  id?: string;
  showOrientation?: boolean;
}

const LiveGastronom: FC<Props> = ({
  foodTrays,
  selectedFoodTray,
  setSelectedFoodTray,
  id,
  containingFoodLineId,
  setContainingFoodLineId,
  showOrientation,
}) => {
  const setSelectedFoodLine = newSelectedFoodTray => {
    if (setSelectedFoodTray && setContainingFoodLineId) {
      setSelectedFoodTray(newSelectedFoodTray);
      setContainingFoodLineId(id);
    }
  };

  return (
    <section className='live-gastronom'>
      <GastronomGrid
        showOrientation={showOrientation}
        foodTrays={foodTrays}
        selectedFoodTray={id === containingFoodLineId && selectedFoodTray}
        setSelectedFoodTray={setSelectedFoodTray && setSelectedFoodLine}
      />
    </section>
  );
};

export default LiveGastronom;
